/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const PowerpointBrainstormActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.BrainStormDialog,
    checked: false,
    primaryContent: strings.getString('trialconversionPowerpointBrainStormDialogHeader'),
    secondaryContent: strings.getString('trialconversionPowerpointBrainStormDialogContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionPowerpointCard', 'Get design ideas clicked'),
    retriggerable: true
});
